<template>
  <div id="all auth-page password-recovery">
    <div id="ajax-upload">
      <main id="main">
        <div class="container">
          <div class="auth-box">
            <div class="logo">
              <IconLogo/>
            </div>
            <div class="auth-form" v-if="!successMessage">
              <p class="h2 title line ">Password recovery</p>
              <p>Enter your email and we will send you a new password.</p>
              <form class="form" @submit.prevent="requestClick" novalidate>
                <div class="field">
                  <label class="field-name">Email</label>
                  <input type="email" class="form-control" placeholder="Your Email" v-model="email" v-on:keydown.enter.prevent="requestClick" @blur="v$.email.$touch" @keydown="errorMessage=''">
                </div>
                <p style="color: red" v-for="(error, index) of v$.email.$errors" v-bind:key="index" >{{error.$message}}</p>
                <p style="color: red">{{errorMessage}}</p>
                <div class="form-btn-box">
                  <button type="button" class="btn success small" @click.prevent="requestClick" :disabled="loading">
                    <span>{{loading ? 'Reset...' : 'Reset'}}</span>
                  </button>
                </div>
              </form>
            </div>
            <div v-else>
              <p class="h2 title line ">Password recovery</p>
              <p>{{successMessage}}</p>
            </div>
          </div>
        </div>
      </main>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import IconLogo from "./common/icons/IconLogo";
import { useVuelidate } from "@vuelidate/core";
import { required, email } from "@vuelidate/validators";
import {toggleBodyClass} from "../common"

export default {
    name: 'Login',
    components: {IconLogo},
    setup () {
        return { v$: useVuelidate() }
    },
    data() {
        return {
            email: '',
            token: '',
            errorMessage: '',
            successMessage: '',
            loading: false,
        }
    },
    validations() {
        return {
            email: {required, email}
        }
    },
    methods: {
        requestClick() {
            this.v$.$touch();

            if (this.v$.$error) {
                return false;
            }

            this.loading = true;

            return new Promise((resolve) => {
                setTimeout(() => {
                    axios.post('/api/restore-password', {email: this.email})
                        .then((response) => {
                            if (response.data.success) {
                                this.successMessage = response.data.message;
                            } else {
                                this.errorMessage = response.data.message
                            }
                            this.loading = false;
                        })
                        .catch((error) => {
                            console.log(error)
                            this.loading = false;
                        });
                    resolve()
                }, 1000);
            });

        },
    },
    mounted() {
        toggleBodyClass('addClass', 'auth-page');
        toggleBodyClass('addClass', 'password-recovery');
    },
    unmounted() {
        toggleBodyClass('removeClass', 'auth-page');
        toggleBodyClass('removeClass', 'password-recovery');
    }



}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
